module.exports = __webpack_public_path__ + "static/media/DSCF6350.e271e82c.jpg";